// removed by extract-text-webpack-plugin
module.exports = {"backgroundWhite":"backgroundWhite_2PNnF","background":"background_1BAcs","centerImage":"centerImage_3ck7Y","centerTip":"centerTip_353KS","companyNameInputWrap":"companyNameInputWrap_2p6C1","companyNameInput":"companyNameInput_5aGtq","invalidNameTip":"invalidNameTip_2N3Zt","submitCompanyNameButton":"submitCompanyNameButton_3f7Fz","createCompanySuccess":"createCompanySuccess_Zhnfk","validationCodeInput":"validationCodeInput_2LNZ-","emailInput":"emailInput_mq-fA"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/ucBindEmail/index.scss
 ** module id = 2089
 ** module chunks = 43
 **/